<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="error" class="alert_success" v-if="alert_error_year === true">ปีที่สิ้นสุดต้องไม่น้อยกว่าปีที่เริ่ม</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card class="pa-3">
            <div class="mb-3">
                <h2>รายงานต้นทุนรายวัน</h2>
            </div>
            <div class="mb-3 d-flex option_date_daily_cost_report_list">
                <div>
                    <v-select label="เลือกประเภทวันที่" v-model="date_type" @change="reDateType" :items="date_type_list" item-text="name" item-value="type" outlined>
                    </v-select>
                </div>
                <!-- ปี -->
                <div class="mx-2" v-if="date_type == 'y'">
                    <v-select label="ปีที่เริ่ม" v-model="start_date" :items="yearList" item-text="name_be" item-value="name" @change="searchYear" outlined>
                    </v-select>
                </div>
                <div v-if="date_type == 'y'">
                    <v-select label="ปีที่สิ้นสุด" v-model="end_date" :items="yearList" item-text="name_be" item-value="name" @change="searchYear" outlined>
                    </v-select>
                </div>
                <!-- เดือน -->
                <div class="mx-2" v-if="date_type == 'm'">
                    <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="start_date_be" label="เดือนที่เริ่ม (เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="start_date" :max="end_date" type="month" no-title scrollable locale="th" :events="dateStartEndBE('start_month')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate('start_month')">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_start_date = false">
                                ยกเลิก
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div v-if="date_type == 'm'">
                    <v-menu ref="menu_end_date" v-model="menu_end_date" :close-on-content-click="false" :return-value.sync="end_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="end_date_be" label="เดือนที่สิ้นสุด (เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="end_date" :min="start_date" type="month" no-title scrollable locale="th" :events="dateStartEndBE('end_month')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate('end_month')">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_end_date = false">
                                ยกเลิก
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <!-- วันที่ -->
                <div class="mx-2" v-if="date_type == 'd'">
                    <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="start_date_be" label="วันที่เริ่ม (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="start_date" :max="end_date" no-title scrollable locale="th" :events="dateStartEndBE('start_date')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate('start_date')">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_start_date = false">
                                ยกเลิก
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div v-if="date_type == 'd'">
                    <v-menu ref="menu_end_date" v-model="menu_end_date" :close-on-content-click="false" :return-value.sync="end_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="end_date_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="end_date" :min="start_date" no-title scrollable locale="th" :events="dateStartEndBE('end_date')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate('end_date')">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_end_date = false">
                                ยกเลิก
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
            </div>
            <div class="mb-3">
                <v-card class="pa-3 mb-3">
                    กำไรสุทธิ
                </v-card>
                <div class="chart_daily_cost_report_list d-flex justify-center align-center">
                    <canvas id="my-chart-out"></canvas>
                </div>
            </div>
            <div>
                <div class="grid_daily_cost_report_list mb-3">
                    <div class="mr-1">
                        <v-card class="pa-3 mb-3 white--text" color="success">
                            รายได้
                        </v-card>
                        <div class="mb-3">
                            <div class="pl-3 pb-3 d-flex justify-space-between">
                                <div>รายได้ร้านอาหาร</div>
                                <div>{{ income_store }}</div>
                            </div>
                            <hr>
                        </div>
                        <div class="mb-3">
                            <div class="pl-3 pb-3 d-flex justify-space-between">
                                <div>รายได้จากเดลิเวอรี่</div>
                                <div>{{ income_accrued }}</div>
                            </div>
                            <hr>
                        </div>
                        <div class="mb-3">
                            <div class="pl-3 pb-3 d-flex justify-space-between">
                                <div>รายได้การขายจากทางอื่น</div>
                                <div>{{ income_other }}</div>
                            </div>
                            <hr>
                        </div>
                        <div class="mb-3 d-flex justify-space-between">
                            <div>รวมรายได้</div>
                            <div>{{ sum_income }}</div>
                        </div>
                    </div>
                    <div class="ml-1">
                        <v-card class="pa-3 mb-3 white--text" color="error">
                            ต้นทุน
                        </v-card>
                        <div class="mb-3">
                            <div class="pl-3 pb-3 d-flex justify-space-between">
                                <div>ต้นทุนวัตถุดิบ</div>
                                <div>{{ cost_material }}</div>
                            </div>
                            <hr>
                        </div>
                        <div class="mb-3">
                            <div class="pl-3 pb-3 d-flex justify-space-between">
                                <div>ต้นทุนอื่นๆ</div>
                                <div>{{ cost_other }}</div>
                            </div>
                            <hr>
                        </div>
                        <div class="d-flex justify-space-between">
                            <div>รวมต้นทุน</div>
                            <div>{{ sum_cost }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>

    </div>
</div>
</template>

<script>
import dailycostreport from '@/api/account/accountreport/dailycostreport.js'
import Chart from 'chart.js/auto'
// import 'chartjs-plugin-labels'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            alert_error_year: false,
            date_type_list:[
                {
                    name:'ปี',
                    type:'y',
                },
                {
                    name:'เดือน',
                    type:'m',
                },
                {
                    name:'วัน',
                    type:'d',
                },
            ],
            date_type:null,
            menu_start_date: false,
            start_date_be: '',
            start_date: '',
            menu_end_date: false,
            end_date_be: '',
            end_date: '',
            income_store: 0,
            income_accrued: 0,
            income_web: 0,
            income_other: 0,
            sum_income: 0,
            cost_material: 0,
            cost_other: 0,
            sum_cost: 0,
        }
    },

    methods: {
        async reDateType(){
            this.menu_start_date = false
            this.start_date_be = ''
            this.start_date = ''
            this.menu_end_date = false
            this.end_date_be = ''
            this.end_date = ''
        },
        async searchYear(){
            if (this.start_date && this.end_date) {
                if (this.start_date > this.end_date) {
                    this.alert_error_year = true
                    setTimeout(() => this.alert_error_year = false, 5000)
                }else{
                    this.chartAll()
                }
            }
        },
         dateStartEndBE(type) {
            if (type == 'start_date') {
                if (this.start_date == '') {
                    this.start_date_be = ''
                }
                if (this.start_date) {
                    let date_arr = this.start_date.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.start_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'end_date') {
                if (this.end_date == '') {
                    this.end_date_be = ''
                }
                if (this.end_date) {
                    let date_arr = this.end_date.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.end_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'start_month') {
                if (this.start_date == '') {
                    this.start_date_be = ''
                }
                if (this.start_date) {
                    let date_arr = this.start_date.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.start_date_be = `${month}/${year}`
                }
            }
            if (type == 'end_month') {
                if (this.end_date == '') {
                    this.end_date_be = ''
                }
                if (this.end_date) {
                    let date_arr = this.end_date.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.end_date_be = `${month}/${year}`
                }
            }
        },
        async searchDate(type) {
            if (type == 'start_date') {
                this.$refs.menu_start_date.save(this.start_date)
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_start_date = false
            }
            if (type == 'end_date') {
                this.$refs.menu_end_date.save(this.end_date)
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_end_date = false
            }
            if (type == 'start_month') {
                this.$refs.menu_start_date.save(this.start_date)
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${month}/${year}`
                this.menu_start_date = false
            }
            if (type == 'end_month') {
                this.$refs.menu_end_date.save(this.end_date)
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${month}/${year}`
                this.menu_end_date = false
            }
            if (this.start_date && this.end_date) {
                this.chartAll()
            }
        },
        async chartAll() {
            this.loading_page = true
            let chart_list = []
            let max_chart_value = []
            await dailycostreport.dailyCostReportList(this.date_type,this.start_date,this.end_date).then((response) => {
                if (response.data.successful === true) {
                    this.income_store = response.data.detail.incomStore
                    this.income_accrued = response.data.detail.incomAccrued
                    this.income_web = response.data.detail.icomWeb
                    this.income_other = response.data.detail.incomOther
                    this.sum_income = response.data.detail.sumIncom
                    this.cost_material = response.data.detail.costMat
                    this.cost_other = response.data.detail.costOther
                    this.sum_cost = response.data.detail.sumCost
                    chart_list = response.data.list
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            let ctx_out = document.getElementById('my-chart-out')
            let income_chart_list = chart_list.map((detail) => { return detail.incom})
            let cost_chart_list = chart_list.map((detail) => { return detail.cost})

            let income_chart_max_list = Math.max(...income_chart_list)
            let cost_chart_max_list = Math.max(...cost_chart_list)
            max_chart_value = (income_chart_max_list + cost_chart_max_list)

            new Chart(ctx_out, {
                type: 'bar',
                data: {
                    labels: chart_list.map((detail) => { return detail.date}),
                    datasets: [
                        {
                            label: 'รายได้',
                            data: income_chart_list,
                            backgroundColor: chart_list.map(() => {
                                return '#4caf50'
                            }),
                        },
                        {
                            label: 'ต้นทุน',
                            data: cost_chart_list,
                            backgroundColor: chart_list.map(() => {
                                return '#ff5252'
                            }),
                        },
                    ]
                },
                options: {
                    legend: {
                        display:false
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        labels: {
                            render: 'value',
                            fontColor: chart_list.map(() => {
                                return '#000000'
                            }),
                            precision: 2
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                max: this.date_type && this.start_date && this.end_date ? max_chart_value + 1000 : 1000,
                                beginAtZero: true
                            }
                        }]
                    },
                }
            })
        }
    },
    computed: {
         yearList() {
            let first_year = 2020
            let last_year = new Date().getFullYear()
            let year_list = []
            for (let index = first_year; index <= last_year; index++) {
                year_list.push({
                    name: index,
                    name_be: index + 543
                })
            }
            return year_list
        },
    },
    mounted() {
        this.chartAll()
    }

}
</script>

<style scoped>
.option_date_daily_cost_report_list>div:first-child {
    width: 20%;
}
.option_date_daily_cost_report_list>div {
    width: 40%;
}

.grid_daily_cost_report_list {
    display: grid;
    grid-template-columns: 50% 50%;
}

.chart_daily_cost_report_list {
    height: 100%;
}
</style>
